import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-desk-settings',
  templateUrl: './service-desk-settings.component.html',
  styleUrls: ['./service-desk-settings.component.css']
})
export class ServiceDeskSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
